import env_awsmobile from '../aws-exports';
export default env_awsmobile[process.env.REACT_APP_ENVIRONMENT || 'staging'];
